//autocomplete dokumentace: https://tarekraafat.github.io/autoComplete.js/#/configuration
const Autocomplete = (function () {
    var resultContainer;
    var autocompleteIconClose;
    var autocompleteIconSearch;
    var autocompleteJsInput;
    var limit = 10;
    var webBaseUrl = window.location.origin;

    let autoCompleteJS = null;
    let options = null;
    let resultsProvider = null;
    let sessionToken = null;
    let map = null;

    function init(initOptions) {
        if (typeof autoComplete === 'undefined') {
            console.warn('autoComplete.js is not loaded');
            return;
        }

        options = initOptions;
        resultsProvider = options.resultsProvider;
        map = options.map;
        if(resultsProvider == 'google-api') setNewSessionToken();
        cacheDomElements();
        createAutocomplete();
        bindEvents();
    }

    function setNewSessionToken() {
        if (window.crypto && typeof crypto.randomUUID === 'function') {
            sessionToken = crypto.randomUUID();
            return;
        }

        // fallback pro old Internet Explorer, atd.:
        sessionToken = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0;
            var v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    function cacheDomElements() {
        resultContainer = $(options.resultContainer);
        autocompleteIconClose = $(options.iconClose);
        autocompleteIconSearch = $(options.iconSearch);
        autocompleteJsInput = document.querySelector(options.input);
    }

    function createAutocomplete() {
        autoCompleteJS = new autoComplete({
            selector: () => autocompleteJsInput,
            diacritics: true, // akceptuje diakritiku
            wrapper: false, // nezabali input a vysledky do wrapper divu
            debounce: 300, //300ms cekani po poslednim stisknutem pismenu nez se zacnou hledat vysledky
            threshold: 2, //hledani vysledku az po zadani 2 znaku
            searchEngine: (query, record) => `<mark>${record}</mark>`,

            data: {
                src: async (query) => {
                    try {
                        let autocompleteOptions = {};

                        if(map) {
                            setLocationBiasData(autocompleteOptions);
                        }

                        if(resultsProvider == 'google-api') {
                            autocompleteOptions.sessionToken = sessionToken;
                        }


                        const response = await fetch(webBaseUrl + "/api/branches-map/autocomplete", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "Accept": "application/json",
                            },
                            body: JSON.stringify({
                                provider: resultsProvider,
                                query: query,
                                options: autocompleteOptions,
                            }),
                        });

                        const text = await response.text();

                        if (!response.ok) {
                            console.error(`Autocomplete (provider:${resultsProvider}) API HTTP error:`, response.status, text);
                            return [];
                        }

                        let jsonData;
                        try {
                            jsonData = JSON.parse(text);
                        } catch (e) {
                            console.error('Autocomplete API returned non-JSON:', text);
                            return [];
                        }

                        return jsonData.results;

                    } catch (exc) {
                        console.log(exc);
                        return [];
                    }
                },
            },

            resultsList: {
                tag: "ul",
                noResults: true,
                maxResults: limit,
                destination: '#' + resultContainer.attr('id'),
                position:'afterbegin',
                class: "branches-leaflet__autocomplete-js__result-list scroll-blur small-scrollbar",
                element: (list, data) => {
                    if (!data.results.length) {
                        var noResultDiv = $("<div>", {
                            "class": "branches-leaflet__autocomplete-js__no-result-item",
                        });
                        noResultDiv.html(`${options.langTexts.apiMapyAddressSearch.noResultsFound.replace('{query}', data.query)}`);
                        //$(list) === prekonvertovani na jquery object
                        $(list).prepend(noResultDiv);
                    }
                },
            },

            resultItem: {
                tag: "li",
                class: "branches-leaflet__autocomplete-js__result-item",
                element: (item, data) => {
                    var itemData = data.value;
                    var title = itemData.name;
                    var description = resultsProvider == 'mapy-api' ? `${itemData.label}, ${itemData.location}` : `${itemData.label ? itemData.label : ''}`;
                    var descriptionHtml = description.length ?
                        `
                        <span class="branches-leaflet__autocomplete-js__result-item__label-and-location">
                            ${description}
                        </span>
                        ` : '';

                    var resultItemWrapper = $("<div>", {
                        "class": `branches-leaflet__autocomplete-js__result-item__wrapper`,
                    });

                    var resultItemHtml =
                        `
                        <div class="branches-leaflet__autocomplete-js__result-item__icon">
                            <img src="${options.iconPositionUrl}" style="height:26px; width:26px;">
                        </div>

                        <div class="branches-leaflet__autocomplete-js__result-item__data-wrapper">
                            <span class="branches-leaflet__autocomplete-js__result-item__title">
                                ${title}
                            </span>
                            ${descriptionHtml}
                        </div>
                        `;

                    resultItemWrapper.append(resultItemHtml);
                    //$(item) === prekonvertovani na jquery object, .empty() kvuli mazani puvodniho obsahu
                    $(item).empty().append(resultItemWrapper);
                },
            },

            events: {
                input: {
                    focus: (event) => {
                        var inputValue = autoCompleteJS.input.value;
                        if (inputValue.length >= autoCompleteJS.threshold) {
                            var isContainerHidden = resultContainer.is(":hidden");
                            if (isContainerHidden) toggleAutocompleteResult();
                            autoCompleteJS.open();
                        }
                    },
                    blur: (event) => {
                        var inputValue = autoCompleteJS.input.value;
                        if (inputValue.length >= autoCompleteJS.threshold) {
                            toggleAutocompleteResult();
                            autoCompleteJS.close();
                        }

                    }
                },
            },
        });
    }

    function bindEvents() {
        autocompleteIconSearch.on("click", event => {
            if (!canShowResults()) return;
            var isContainerHidden = resultContainer.is(":hidden");
            if (isContainerHidden) toggleAutocompleteResult();
            autoCompleteJS.open();
        });

        autocompleteIconClose.on("click", event => {
            if (!canShowResults()) return;
            toggleAutocompleteResult();
        });

        autocompleteJsInput.addEventListener("results", function (event) {
            showResultsIfNeeded();
        });

        autocompleteJsInput.addEventListener("input", function (event) {
            if (event.target.value.length < autoCompleteJS.threshold) {
                hideResultsIfNeeded();
            }
        });

        bindSelectionEvent();
    }

    function bindSelectionEvent() {
        autocompleteJsInput.addEventListener("selection", async (event) => {
            let selectedItem = event.detail?.selection?.value;
            if (!selectedItem) return;

            let payload = await resolveSelectionData(selectedItem);
            handleSelection(payload);
            autocompleteJsInput.blur();
            var isContainerHidden = resultContainer.is(":hidden");
            if(!isContainerHidden) toggleAutocompleteResult();
        });
    }

    async function resolveSelectionData(selectedItem) {
        // autocompleteJsInput.value = selectedItem.name; //kdybych chtel prepsat text v inputu textem, na ktery jsem klikl
        if (resultsProvider === 'google-api') {
            let result = await googlePlaceDetailsSearch(selectedItem.placeId, sessionToken);
            setNewSessionToken();
            if (!result) {
                console.warn('Google Place Details returned null', selectedItem);
                return null;
            }

            return {
                lat: result.position.lat,
                lng: result.position.lon,
                zoom: result.mapZoom,
                label: selectedItem.name,
            };
        }

        return {
            lat: selectedItem.position.lat,
            lng: selectedItem.position.lon,
            zoom: selectedItem.mapZoom,
            label: selectedItem.name,
        };
    }

    async function googlePlaceDetailsSearch(placeId, sessionToken) {
        try {
            const response = await fetch(webBaseUrl + "/api/branches-map/get-place-details", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                },
                body: JSON.stringify({
                    placeId: placeId,
                    sessionToken: sessionToken
                }),
            });

            const text = await response.text();

            if (!response.ok) {
                console.error('Google Place Details API error:', response.status, text);
                return null;
            }

            return JSON.parse(text).result ?? null;

        } catch (err) {
            console.error(err);
            return null;
        }
    }

    function handleSelection(payload) {
        if (typeof options.onLocationSelected === 'function') {
            options.onLocationSelected(payload);
        }
    }

    function toggleAutocompleteResult()
    {
        var isContainerHidden = resultContainer.is(":hidden");
        if(isContainerHidden)
        {
            autocompleteIconClose.css('display', 'flex');
            autocompleteIconSearch.css('display', 'none');
            resultContainer.attr('hidden',!isContainerHidden);
        } else {
            autocompleteIconClose.css('display', 'none');
            autocompleteIconSearch.css('display', 'flex');
            resultContainer.attr('hidden',!isContainerHidden);
        }
    }

    function canShowResults() {
        return autoCompleteJS.input.value.length >= autoCompleteJS.threshold;
    }

    function showResultsIfNeeded() {
        if (canShowResults() && resultContainer.is(":hidden")) {
            toggleAutocompleteResult();
        }
    }

    function hideResultsIfNeeded() {
        if (!resultContainer.is(":hidden")) {
            toggleAutocompleteResult();
        }
    }

    function setLocationBiasData(autocompleteOptions) {
        let mapCenter = map.getCenter();
        if(resultsProvider == 'mapy-api') {
            autocompleteOptions.preferNear = {
                lng: mapCenter.lng,
                lat: mapCenter.lat
            };
        }

        if(resultsProvider == 'google-api') {
            autocompleteOptions.locationBias = {
                circle: {
                    center: {
                        latitude: mapCenter.lat,
                        longitude: mapCenter.lng,
                    },
                    radius: 50000.0
                },

            };
        }
    }

    return { init };
})();

export default Autocomplete;